export default __webpack_public_path__ + "static/media/benefits_fastrackicon.00c61c3e.svg";